module.exports = __webpack_public_path__ + "img/bubble.7d5c8e22.jpg";